import { render } from "./DiagnosisClock.vue?vue&type=template&id=280d25c6&scoped=true"
import script from "./DiagnosisClock.vue?vue&type=script&lang=js"
export * from "./DiagnosisClock.vue?vue&type=script&lang=js"

import "./DiagnosisClock.vue?vue&type=style&index=0&id=280d25c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280d25c6"]])

export default __exports__